// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__181Zv","inputWrap":"CustomTip_inputWrap__2sN7U"};